module.exports = __webpack_public_path__ + "img/jywh.a05da57c.svg";